var _path, _path2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8SamoaCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M44,24c0,11.046-8.954,20-20,20S4,35.046,4,24c0-2.216,0.898-4.571,1.564-6.564 C6.849,13.589,14.489,11,14.489,11s1.092-4.019,2.559-4.66c2.451-1.072,4.149-1.83,6.995-1.83c0.923,0,1.79-0.448,2.68-0.327 C36.48,5.512,44,13.877,44,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#283593",
    d: "M4,24h22.995V4.235C25.988,4.107,24.967,4.026,23.932,4C12.887,4.228,4,13.086,4,24z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceff1",
    points: "17.098,7.006 17.543,8.322 18.932,8.339 17.819,9.169 18.231,10.495 17.098,9.693 15.964,10.495 16.377,9.169 15.263,8.339 16.652,8.322"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceff1",
    points: "12.083,11.095 12.529,12.411 13.918,12.428 12.804,13.258 13.217,14.584 12.083,13.782 10.95,14.584 11.363,13.258 10.249,12.428 11.638,12.411"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceff1",
    points: "22.185,10.324 22.616,11.597 23.96,11.614 22.882,12.417 23.282,13.7 22.185,12.924 21.088,13.7 21.487,12.417 20.41,11.614 21.754,11.597"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceff1",
    points: "17.061,17.675 17.613,19.306 19.335,19.327 17.955,20.356 18.466,22 17.061,21.006 15.656,22 16.167,20.356 14.787,19.327 16.509,19.306"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceff1",
    points: "19.535,14.534 19.82,15.376 20.709,15.387 19.996,15.918 20.26,16.767 19.535,16.253 18.81,16.767 19.074,15.918 18.361,15.387 19.25,15.376"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8SamoaCircular);
export default __webpack_public_path__ + "static/media/icons8-samoa-circular.261cb05cf019ed7c0f757027b4f2f71b.svg";
export { ForwardRef as ReactComponent };